import React, { useDispatch, useState, useEffect, useMemo } from 'reactn'
import { ArrowForwardIcon } from '@chakra-ui/icons'
import CartError from './cartError'
import {
  Box, Button, Center, HStack, Spinner, VStack, Divider, Flex, useBreakpointValue, Checkbox, Text,
} from "@chakra-ui/react"
import {
  Elements, AddressElement, LinkAuthenticationElement,
} from "@stripe/react-stripe-js"
import './checkout.css'

const styleVariables = {
  colorPrimary: '#000',
  colorBackground: '#fff',
  fontWeight: '300',
  borderRadius: '0px',
  fontSize: '14px',
  colorText: '#30313d',
  colorDanger: '#df1b41',
  colorIcon: '#000',
  colorLogo: 'light',
  fontWeightLight: '300',
  fontWeightNormal: '300',
  fontWeightMedium: '300',
  fontFamily: 'ApercuLight, Roboto, Open Sans, Segoe UI, sans-serif',
  spacingUnit: '2px',
}

import PaymentForm from './cartPayment';
import ShippingForm from './sections/shipping';
import ShoppingCartTotals from './shoppingCartTotals';
// import CartUpsells from './sections/cartUpsells';
import ExpressPayment from './expressPayment';
import { Dots } from './dotsAnimation';
import { useOnlineStatus } from '../utils/onlineStatus'

const appearance = {
  theme: 'none',
  rules: {
    '.Input': {
      border: '1px solid #000',
      borderRadius: '0px',
      boxShadow: 'none',
      fontSize: '14px',
      letterSpacing: 'normal',
      padding: '10px',
      outline: 'none',
      marginBottom: '0px',
      textTransform: 'uppercase',
    },

    '.Input--empty': {
      border: '1px solid #000',
      padding: '10px',
      marginBottom: '0px',
    },

    '.AccordionItem': {
      border: '0px solid #000',
      borderRadius: '0px',
      boxShadow: 'none',
      textTransform: 'uppercase',
    },

    '.Input:focus-visible': {
      border: '1px solid #000',
      borderRadius: '0px',
      boxShadow: 'none',
      textTransform: 'uppercase',
      outline: 'none !important',
    },

    '.PickerItem': {
      border: '0px solid #000',
      borderRadius: '0px',
      paddingLeft: '0px',
      boxShadow: 'none',
      textTransform: 'uppercase',
    },

    '.PickerItem--selected': {
      border: '0px solid #000',
      borderRadius: '0px',
      marginLeft: '0px',
      boxShadow: 'none',
      textTransform: 'uppercase',
    },

    '.CodeInput': {
      border: '1px solid #000',
      borderRadius: '0px',
      boxShadow: 'none',
    },

    '.MenuAction': {
      textTransform: 'uppercase',
      fontSize: '12px',
      borderRadius: '0px',
    },

    '.PickerAction': {
      textTransform: 'uppercase',
      fontSize: '12px',
      borderRadius: '0px',
    },

    '.Block': {
      border: '1px solid #000',
      borderRadius: '0px',
      marginLeft: '0px',
      boxShadow: 'none',
    },

    '.CheckboxInput': {
      border: '1px solid #000',
      borderRadius: '0px',
      boxShadow: 'none',
    },

    '.Input::placeholder': {
      color: 'red',
      opacity: '0.5'
    },
    '.Input:hover': {
      color: 'var(--colorText)'
    },

    '.Input--selected': {
      borderColor: '#000',
      borderRadius: '0px',
      boxShadow: 'none',
    },

    '.Accordion:focus-visible': {
      borderColor: '#000',
      borderRadius: '0px',
      boxShadow: 'none',
    },

    '.Label': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },

    '.TabLabel': {
      textTransform: 'uppercase',
      fontSize: '14px'
    },

    '.Tab': {
      border: '1px solid #000',
      borderRadius: '0px',
      boxShadow: 'none',
    },

    '.Tab:focus': {
      border: '2px solid #000',
      boxShadow: 'none',
    },

    '.Tab--selected:focus': {
      border: '2px solid #000',
      boxShadow: 'none',
    },

    '.Input--invalid': {
      boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.07), 0 0 0 2px var(--colorDanger)',
    },
  },
  variables: styleVariables
};

const stripeOptions = (cs) => {
  return {
    clientSecret: cs,
    appearance: appearance
  }
}

const Checkout = ({ globalState }) => {
  // console.log('[CHECKOUT DEBUG] Component rendering');
  const { store, updateGlobal } = globalState
  const { cartTotal, calculating, shipping, pd, ts, os, orderID, stripe, so, soe, preparePayment, showPayment, showShipping, accordianItem, addressRequired, marketing, accepts_marketing, shipping_address, contactNumber, fullName, emailAddress } = store

  const [error, setError] = useState("")
  const fetchCart = useDispatch('fetchCart')
  const isOnline = useOnlineStatus();
  const [processing, setProcessing] = useState(false)
  const [isReady, setIsReady] = useState(false)
  const [addressComplete, setAddressComplete] = useState(false)
  const [emailComplete, setEmailComplete] = useState(false)
  const [countryCode, setCountryCode] = useState(shipping_address?.country_code)
  const [formData, setFormData] = useState({})

  function setPreparePayment(preparePayment) {
    updateGlobal({ preparePayment: preparePayment })
  }

  const splitView = useBreakpointValue([false, false, true, true])
  const setAddress = useDispatch('setAddress')
  console.log("EMAIL ADDRESS",globalState)
  function setShowShipping(showShipping, accordianItem, countryChange = false) {
    updateGlobal({ showShipping: showShipping, showPayment: false, accordianItem: accordianItem, countryChange: countryChange })
  }

  function setShowPayment(showPayment) {
    updateGlobal({ showPayment: showPayment })
  }

  function setAccorianItem(accordianItem) {
    updateGlobal({ accordianItem: accordianItem, showPayment: false })
  }

  const [fetchShipping, setFetchShipping] = useState(false)
  // const [expressAmount, setExpressAmount] = useState(0);

  // Memoize stripe options to prevent Elements from remounting
  const memoizedStripeOptions = useMemo(() => {
    // console.log('[CHECKOUT DEBUG] Creating memoized stripe options, cs:', pd?.cs?.substring(0, 20) + '...');
    if (!pd?.cs) return null;
    return {
      clientSecret: pd.cs,
      appearance: appearance
    };
  }, [pd?.cs]);

  // Memoize fonts array to prevent Elements from remounting
  const stripeFonts = useMemo(() => {
    // console.log('[CHECKOUT DEBUG] Creating memoized fonts array');
    return [
      {family: 'ApercuLight', src: 'url(https://ingmarson.com/fonts/apercu-light.woff)', weight: '300'}
    ];
  }, []);

  useEffect(() => {
    fetchCart()
  }, [fetchShipping]);

  // Set emailComplete based on emailAddress if it exists
  useEffect(() => {
    if (emailAddress && emailAddress.includes('@') && emailAddress.includes('.')) {
      setEmailComplete(true)
    }
  }, [emailAddress]);

  // // Update express amount when global store price changes
  // useEffect(() => {
  //   if (ts?.total_price_pence && ts.total_price_pence > 0) {
  //     setExpressAmount(ts.total_price_pence);
  //   }
  // }, [ts?.total_price_pence]);

  useEffect(() => {
    if (preparePayment == true) {
      fetchCart()
    }
  }, [preparePayment]);

  const changeAccordian = (expandedIndex, countryCode = '') => {
    if (expandedIndex == 0) {
      setShowShipping(false, expandedIndex)
      setCountryCode(countryCode)
    } else {
      setAccorianItem(expandedIndex)
    }
  }

  const buttonMessage = () => {
    if (calculating) {
      return ""
    }
    if (!addressRequired) {
      return "COMPLETE PAYMENT"
    } else if (addressRequired && !showPayment && showShipping && ts.shipping_line && ts.shipping_line.title) {
      return "CONTINUE TO PAYMENT"
    } else if (addressRequired && showPayment) {
      return "PAY NOW"
    } else {
      return "UPDATE CART"
    }
  }

  const pressButton = () => {
    if (addressRequired && !showPayment && showShipping && ts.shipping_line && ts.shipping_line.title) {
      setPreparePayment(true)
    } else if (addressRequired && showPayment) {
      // setProcessing(true)
      updateGlobal({ calculating: true, processPayment: true })
    } else {
      fetchCart()
    }
  }

  const handleCheckoutSubmit = async (event) => {
    event.preventDefault();
    if (showShipping && shipping.calculated) {
      setShowPayment(true)
    } else {
      // Check if we have a complete address from express checkout or local form
      const hasCompleteAddress = formData.complete || (shipping_address && shipping_address.complete)

      if (hasCompleteAddress) {
        let stripeData, stripeAddress, otherData

        if (formData.complete) {
          // Use local form data
          stripeData = formData.value;
          stripeAddress = stripeData.address;
          otherData = {
            fullName: stripeData.name,
            contactNumber: stripeData.phone,
            showShipping: true,
            accordianItem: 1,
            calculating: false
          }
        } else {
          // Use global address data from express checkout
          stripeAddress = {
            country: shipping_address.country_code,
            postal_code: shipping_address.zip,
            line1: shipping_address.address1,
            line2: shipping_address.address2,
            city: shipping_address.city,
            state: shipping_address.province,
            name: shipping_address.name
          }
          otherData = {
            fullName: fullName,
            contactNumber: contactNumber,
            showShipping: true,
            accordianItem: 1,
            calculating: false
          }
        }

        setAddress({
          addressType: 'shipping_address',
          address: {
            country_code: stripeAddress.country,
            zip: stripeAddress.postal_code,
            address1: stripeAddress.line1,
            address2: stripeAddress.line2,
            city: stripeAddress.city,
            province: stripeAddress.state,
            name: stripeAddress.name
          },
          otherData: otherData
        })
      } else {
        let newData = {}
        newData['showShipping'] = false
        newData['accordianItem'] = 0
        newData['calculating'] = false
        newData['countryChange'] = false
        updateGlobal(newData)
      }
    }
    window.scrollTo(0, 0)
  }

  const loader = 'auto';

  console.log('[CHECKOUT DEBUG] Rendering, has memoizedStripeOptions:', !!memoizedStripeOptions, 'has stripeFonts:', !!stripeFonts);

  return (
    <Box minHeight={["80vh","80vh","90vh","90vh","90vh"]} display="flex" flexDirection="column">
      {pd && pd.cs && stripe && memoizedStripeOptions ? (
        <Elements
          fonts={stripeFonts}
          options={memoizedStripeOptions}
          stripe={stripe}
          loader="auto"
        >
          <Flex direction={'column'} flex="1" maxHeight={["100dvh","92dvh","95dvh","95dvh","95dvh"]}>
            <Box position="sticky" top="0" zIndex="10" bg="white" borderColor="gray.200" py={4}>
              <Center>
                <Box id="ExpressCheckout" width="95%" maxW={'600px'} px={4}>
                  <VStack width="100%" spacing={4}>
                    <Box width="100%">
                      <div id="express-checkout-element" style={{ opacity: calculating ? 0.5 : 1, pointerEvents: calculating ? 'none' : 'auto' }}>
                        <ExpressPayment globalState={globalState} disabled={calculating || processing} processing={processing} setProcessing={setProcessing}/>
                      </div>
                    </Box>
                  </VStack>
                </Box>
              </Center>
            </Box>

            <Box id="MainCheckout" flex="1" overflowY={['unset', 'unset', 'scroll', 'scroll']} >
              <Center>
                <Box id="checkout" width="95%" maxW={'600px'} >
                  <Box >
                    {!processing && showPayment && addressRequired && accordianItem > 1 &&
                      <>
                        {pd && pd.pi &&
                          <Box mt={2} id="payment" border={'ActiveBorder'}>
                            {setProcessing == true ? "TRUE" : "FALSE"}
                            <PaymentForm globalState={globalState} setProcessing={setProcessing} setIsReady={setIsReady}/>
                          </Box>
                        }
                        <Divider mt={5} mb={5} borderColor="blackAlpha.500" />
                      </>
                    }
                    {processing ?
                    <Flex direction={'column'} flex="1" maxHeight={["100dvh","92dvh","95dvh","95dvh","95dvh"]}>
                    <Box flex="1" display="flex" alignItems="center" justifyContent="center">
                      <VStack spacing={4}>
                        <Box>
                          <Dots backgroundColor="#000" />
                        </Box>
                        <Text
                          fontSize="14px"
                          fontWeight="300"
                          textTransform="uppercase"
                          letterSpacing="1px"
                          color="gray.600"
                        >
                          Processing payment
                        </Text>
                      </VStack>
                    </Box>
                  </Flex>
                    : (
                    <Box height="100%" marginLeft={'1px'}>
                      <Flex mt={2} mb={2}>
                        <Text mt={0} variant={'checkout_header'}>CONTACT DETAILS</Text>
                      </Flex>
                      <Box mb={0}>
                        <LinkAuthenticationElement
                          options={{ defaultValues: { email: emailAddress } }}
                          onChange={(event) => {
                            updateGlobal({ emailAddress: event.value.email, showPayment: false })
                            if (event.complete) {
                              setEmailComplete(true)
                            } else {
                              setEmailComplete(false)
                            }
                          }}
                        />
                      </Box>
                      {addressRequired &&
                        <>
                          <Text mt={5} mb={2} variant={'checkout_header'}>SHIPPING ADDRESS</Text>
                          {accordianItem == 0 ?
                            <AddressElement
                              options={{
                                defaultValues: {
                                  name: fullName,
                                  phone: contactNumber,
                                  address: {
                                    line1: shipping_address.address1,
                                    line2: shipping_address.address2,
                                    city: shipping_address.city,
                                    state: shipping_address.locality,
                                    postal_code: shipping_address.zip,
                                    country: shipping_address.country_code
                                  }
                                },
                                mode: 'shipping',
                                fields: { phone: 'always' },
                                validation: { phone: { required: 'always' } }
                              }}
                              onChange={(event) => {
                                const countryChanged = event.value?.address?.country && event.value.address.country !== countryCode
                                if (event.complete) {
                                  setFetchShipping(true);
                                  setFormData(event)
                                  if (!addressComplete) {
                                    setAddressComplete(true)
                                  }
                                } else {
                                  if (addressComplete) {
                                    setAddressComplete(false)
                                  }
                                  setShowShipping(false, 0, countryChanged)
                                }
                              }}
                            />
                            :
                            <Flex mt={2} mb={2}>
                              <Box>
                                <Text variant={'receipt_text_upper'}>{fullName}</Text>
                                <Text variant={'receipt_text_upper'}>{shipping_address?.address1 || ''}</Text>
                                <Text variant={'receipt_text_upper'}>{shipping_address?.address2 || ''}</Text>
                                <Text variant={'receipt_text_upper'}>{shipping_address?.city || ''}</Text>
                                <Text variant={'receipt_text_upper'}>{shipping_address?.locality || ''}</Text>
                                <Text variant={'receipt_text_upper'}>{shipping_address?.zip || ''}</Text>
                                <Text variant={'receipt_text_upper'}>{shipping_address?.country_code || ''}</Text>
                                <Text variant={'receipt_text_upper'}>{contactNumber}</Text>
                              </Box>
                              <Text onClick={() => changeAccordian(0,shipping_address?.country_code)} textAlign={'right'} flex="1" variant={'change_text'}>CHANGE</Text>
                            </Flex>
                          }
                        </>
                      }
                      {accordianItem > 0 &&
                        <>
                          <Flex mt={5} mb={2}>
                            <Text variant={'checkout_header'}>SHIPPING</Text>
                            {accordianItem > 1 &&
                              <Text onClick={() => changeAccordian(1)} textAlign={'right'} flex="1" variant={'change_text'}>CHANGE</Text>
                            }
                          </Flex>
                          <Box>
                            <ShippingForm reload={fetchShipping} allowSelection={accordianItem == 1} globalState={globalState} isDisabled={processing || calculating || !isOnline}/>
                          </Box>
                        </>
                      }
                    </Box>
                    )}
                    {!!status && <Box textTransform={'uppercase'} color="red">{status}</Box>}
                  </Box>
                </Box>
              </Center>
            </Box>
            <Center>
              {!processing && (
              <Box maxW={'600px'} width={"100%"} mt={2}>
                {/* {!accepts_marketing && */}
                  <Checkbox
                    isChecked={marketing}
                    onChange={(e) => updateGlobal({ marketing: e.target.checked, accepts_marketing: true })}
                  >
                    RECEIVE NEWSLETTER / PROMOTIONS
                  </Checkbox>
                {/* } */}
                <Box>
                  {/* <CartUpsells globalState={globalState} /> */}
                  {!splitView &&
                    <ShoppingCartTotals globalState={globalState} />
                  }
                  <CartError />
                  <Center>
                    {addressRequired && !showShipping ?
                      <Button
                        type={'button'}
                        mb={[5,5,0,0]}
                        variant={'checkout'}
                        onClick={(event) => handleCheckoutSubmit(event)}
                        isDisabled={!isOnline || processing || calculating || !addressComplete || !emailComplete}
                        rightIcon={calculating ? <Dots/> : <ArrowForwardIcon />}
                      >
                        {processing ? "PROCESSING PAYMENT" : calculating ? "" : !showShipping ? "CONTINUE TO SHIPPING" : "CONTINUE TO PAYMENT"}
                      </Button>
                      :
                      <Button
                        variant={'checkout'}
                        mb={[5,5,0,0]}
                        type={'button'}
                        isDisabled={!isOnline || processing || calculating }
                        rightIcon={processing || calculating ? <Dots /> : <ArrowForwardIcon />}
                        onClick={() => pressButton(true)}
                      >
                        {buttonMessage()}
                      </Button>
                    }
                  </Center>
                </Box>
              </Box>
              )}
            </Center>
          </Flex>
        </Elements>
      ) : (
        <Flex direction={'column'} flex="1" maxHeight={["100dvh","92dvh","95dvh","95dvh","95dvh"]}>
          <Box flex="1" display="flex" alignItems="center" justifyContent="center">
            <VStack spacing={4}>
              <Box>
                <Dots backgroundColor="#000" />
              </Box>
              <Text
                fontSize="14px"
                fontWeight="300"
                textTransform="uppercase"
                letterSpacing="1px"
                color="gray.600"
              >
                Preparing your checkout
              </Text>
            </VStack>
          </Box>
        </Flex>
      )}
    </Box>
  )
}

export default Checkout